import API from '..';
const ENTITY = 'executives';

export const getItems = () => API.get(`/api/v1/${ENTITY}/`);
